var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('HeadView',{staticClass:"header"}),_c('router-view',{staticClass:"main"}),_c('FooterView',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }